import { Box } from '@customerio/pluma-components/react';

/** Startup-flow completion step. Placeholder — content lands with the startup step PR. */
export function StartupCompleteStep() {
  return <Box data-testid="signup-step-startup-complete" />;
}
